import {faFileImage, faHammer, faPencil} from "@fortawesome/free-solid-svg-icons";
import LargeButton from "./LargeButton";
import Modal from "./Modal";
import {useState} from "react";
import Button from "./Button";
import {GridRow, ColumnGrid} from "./ColumnGrid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormData from "form-data";
import axios from "axios";
import config from '../config.json';
import useCheckPanelAdministrator from "../hooks/useCheckPanelAdministrator";

const MapTemplateCreator = () => {
    const [ showModal, setShowModal ] = useState(false);

    const [ name, setName ] = useState();
    const [ file, setFile ] = useState();

    const { isLoading, panelAdministrator } = useCheckPanelAdministrator();

    if (isLoading || !panelAdministrator) return;

    const create = async () => {
        setShowModal(false);

        const formData = new FormData();

        formData.append("file", file, file.name);
        formData.append("name", name);

        axios({
            url: `${config.backendUrl}/maps/templates`,
            withCredentials: true,
            method: "post",
            headers: { "Content-Type": "multipart/form-data" },
            data: formData
        })
            .then(response => window.location = "/maps?editTemplate=" + response.data.id)
            .catch(error => alert(error.toString()));
    };

    const footer = (
        <div style={{ display: "flex", gap: "20px" }}>
            <Button color="#40b319" onClick={create} content="Create"/>
            <Button color="#c20a0a" onClick={() => setShowModal(false)} content="Cancel"/>
        </div>
    );

    return (
        <div>
            <Modal
                header="New Map Template"
                footer={footer}
                show={showModal}
                onClose={() => setShowModal(false)}>
                <ColumnGrid columns="20px 1fr 1fr">
                    <GridRow>
                        <FontAwesomeIcon icon={faPencil} gap="20px"/>
                        <span>Name</span>
                        <input type="text" onInput={e => setName(e.target.value)}/>
                    </GridRow>
                    <GridRow>
                        <FontAwesomeIcon icon={faFileImage}/>
                        <span>File</span>
                        <input type="file" accept="image/svg+xml" onChange={e => setFile(e.target.files[0])} />
                    </GridRow>
                </ColumnGrid>
            </Modal>
            <LargeButton
                name="New Map Template"
                desc="Upload and configure"
                icon={faHammer}
                color="#5d19e6"
                onClick={() => setShowModal(true)}/>
        </div>
    );
}

export default MapTemplateCreator;
